import { ListItem, ListItemText, Badge, Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import WarningIcon from '@material-ui/icons/Warning';
import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import COVERAGE_CATEGORY from './../../enums/coverageCategories';
import { OrderReviewContext } from './OrderReviewContext';

const propTypes = {
  classes: PropTypes.object.isRequired,
  formHeader: PropTypes.object.isRequired,
  isCancelled: PropTypes.bool,
};

const StepNumberLabel = ({ stepNumber, name }) => (
  <div className={'row-start-center'}>
    <div
      style={{
        borderRadius: '50%',
        backgroundColor: 'white',
        color: 'var(--jmi-blue)',
        fontSize: 12,
        minHeight: 20,
        minWidth: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 20,
        marginLeft: 10,
      }}
    >
      {stepNumber + 1}
    </div>
    <span>{name}</span>
  </div>
);

function ListItemFormHeader({ classes, formHeader, stepNumber, name, isHighConfidencePhotos }) {
  const { state, dispatch } = useContext(OrderReviewContext);
  const [photosWithoutLocation, setPhotosWithoutLocation] = useState(0);
  const isActiveFormHeader = stepNumber === state.activeFormHeaderIndex;
  const formHeaderName = formHeader.duplicateOrder
    ? `${formHeader.name} #${formHeader.duplicateOrder}`
    : formHeader.name;
  const isSupplemental =
    [COVERAGE_CATEGORY.SUPPLEMENTAL_SINGLE, COVERAGE_CATEGORY.SUPPLEMENTAL_MULTIPLE].includes(
      formHeader.coverageCategoryId,
    ) || formHeader.orderable;
  // admins can remove any supplement form (DEFAULT OR NOT), field reps can only remove forms they added
  const canRemoveForm = isSupplemental && (state.isAdmin || formHeader.isRemovable);
  // QA can only remove forms that are in the orderable form headers list
  const isInOrderableList = state.orderableFormHeaders?.some(ofh => ofh.id === formHeader.formHeaderId);
  const QAcanRemoveForm = isSupplemental && (state.isQA || state.isCallCenter) && isInOrderableList;
  
  const handleOnClick = () => {
    dispatch({
      type: 'CHANGE_FORM_HEADER',
      FormHeaderIndex: stepNumber,
    });
  };
  const requestRemoveOrderFormHeader = event => {
    event.stopPropagation();

    dispatch({
      type: 'UPDATE_ORDER_FORM_HEADER_TO_REMOVE',
      orderFormHeader: formHeader,
    });
  };
  const getPhotosWithoutLocation = () => {
    let allImgs = state.formHeaders
      .filter(fh => fh.images)
      .map(fh => fh.images)
      .flat()
      .sort(i => i.formQaImageId);

    let imgWithLoc = state.formHeaders
      .filter(fh => fh.formDefinitions)
      .map(fh => fh.formDefinitions.filter(fd => fd.answerType === 'Picture'))
      .flat()
      .filter(x => x.answers.length > 0)
      .map(x => x.answers[0])
      .filter(x => x.images.length > 0)
      .map(x => x.images)
      .flat();

    let count = allImgs.filter(x => !imgWithLoc.some(z => z.formQaImageId === x.formQaImageId) && !x.hideImage);
    setPhotosWithoutLocation(count.length);
  };

  useEffect(() => {
    getPhotosWithoutLocation();
  }, [state.formHeaders]);

  const isAllPhotosTab = formHeader.orderFormHeaderId === 'all-photos-tab'

  return (
    <ListItem key={formHeader.formHeaderId} button onClick={handleOnClick} selected={isActiveFormHeader}>
      <ListItemText
        primary={<StepNumberLabel stepNumber={stepNumber} name={name || formHeaderName} />}
        primaryTypographyProps={{
          style: {
            color: '#fff',
            fontWeight: isActiveFormHeader ? '600' : '400',
          },
        }}
      />
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        
        {isAllPhotosTab && isHighConfidencePhotos && <WarningIcon style={{ marginRight: 15, fill: "orange" }} />}
        {(canRemoveForm || QAcanRemoveForm) && <DeleteIcon onClick={event => requestRemoveOrderFormHeader(event)} style={{ marginRight: 15 }} />}
        <Badge
          color="error"
          badgeContent={photosWithoutLocation}
          invisible={formHeader.orderFormHeaderId !== 'all-photos-tab' || photosWithoutLocation < 1}
        ></Badge>
      </div>
    </ListItem>
  );
}

const styles = theme => ({});

ListItemFormHeader.propTypes = propTypes;

export default withStyles(styles)(withRouter(ListItemFormHeader));
